<template>
  <div class="flex mb-2" :style="guideStep >= 35 && guideStep <= 39 ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6">
      <div v-show="stageContenttData.localData.showBlock" class="bg-gray-100 rounded-lg p-2">
        <span class="font-bold text-grap-700 align-middle">{{lang['components']['Event']['Regions']['title']}}</span>
        <button
          v-if="!editPageType"
          id="regions"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['Regions']['video_teaching']}}
        </button>
        <div v-show="stageIndex != 0" class="float-right">
          <span class="text-sm mr-2">套用前階段設定</span>
          <InputSwitch v-model="stageContenttData.localData.ditto_local" class="-my-1" :disabled="editPageType" />
        </div>
      </div>
      <div class="flex-1 space-y-4">
        <!-- 新手教學 -->
        <div v-show="stageContenttData.localData.showBlock" class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 36 }">
          <div>
            <!-- <span class="text-red-500">*</span> -->
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Regions']['place_title']}}</span>
            <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="`${lang['components']['Event']['Regions']['place_title_info']}`"></i>
          </div>
          <!-- 新手教學 -->

          <TabView ref="tabview1" @tab-click="onTabClick($event)">
            <TabPanel :header="lang['components']['Event']['Regions']['tab_panel_01']">
              <div class="flex flex-wrap bg-gray-50 w-full p-2 rounded-md border text-gray-600"
                v-if="stageContenttData.localData.locations" :class="{ 'ring-4 border-blue-400': guideStep === 37 }">
                <template v-for="(item, index) in stageContenttData.localData.locations" :key="index">
                  <div class="flex justify-between w-full rounded m-1 p-2 text-sm bg-white border border-gray-200" @click="removeLocations(index)">
                    <span>{{ item.name }}</span>
                    <i class="pi pi-times mt-1" v-if="!editPageType"></i>
                  </div>
                </template>
              </div>
              <div v-if="!editPageType" class=" bg-white rounded-md flex items-center w-full p-2 shadow-sm border border-gray-200">
                <i class="pi pi-search"></i>
                <input type="search" class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                  :placeholder="lang['components']['Event']['Regions']['place_input_placeholder']" :disabled="editPageType" v-model="searchPlace" v-on:keyup="keyup_get_country();">
              </div>
              <Listbox :disabled="editPageType" v-model="country" :options="locations" optionLabel="name" optionValue="key" class="w-full rounded-md"
                emptyMessage="Loading..." v-if="searchPlace.length > 0" />
            </TabPanel>
            <TabPanel :header="lang['components']['Event']['Regions']['tab_panel_02']">
              <div v-if="useGoogleMap == true" class="flex flex-wrap bg-gray-50 w-full p-2 rounded-md border text-gray-600 overflow-y-auto" style="min-height: 84px; max-height: 210px;">
                <template v-for="(item, index) in stageContenttData.localData.location_range" :key="index">
                  <div class="flex justify-between w-full rounded m-1 p-2 text-sm bg-white border border-gray-200 h-14" :class="{ 'ring-2': item.checked == true }" @click="circleStyle(index)">
                    <div class="leading-10">（{{item.center.lat.toFixed(3)}}, {{item.center.lng.toFixed(3)}}）</div>
                    <div class="w-80 leading-4">
                      <InputNumber v-model="item.population" class="float-left" inputId="minmax-buttons" mode="decimal" showButtons :min="1" :max="80" :disabled="editPageType" />
                      <div class="leading-10 float-left ml-2">公里</div>
                    </div>
                    <i v-if="!editPageType" class="pi pi-times leading-10" @click="circleDelect(index)"></i>
                  </div>
                </template>
                <div v-if="circles_info_show == true" class="ml-2" style="line-height:60px;">請在地圖上點出要投遞的區域</div>
              </div>
              <GMapMap
                v-if="useGoogleMap == true"
                :center="center"
                :zoom="6"
                map-type-id="terrain"
                style="width: 100%; height: 500px"
                @click="mapActive($event)"
              >
                <GMapCircle
                  :key="index"
                  v-for="(circle, index) in circles"
                  :radius="circle.radius"
                  :center="circle.center"
                  :options="circle"
                   @click="circleStyle(index)"
                />
                <GMapMarker
                  :key="index"
                  v-for="(circle, index) in circles"
                  :position="circle.center"
                  :clickable="editPageType == false ? true : false"
                  :draggable="editPageType == false ? true : false"
                  @drag="updateCoordinates(index, $event)"
                />
              </GMapMap>
            </TabPanel>
          </TabView>
        </div>
        <!-- 新手教學 -->
        <div v-show="stageContenttData.localData.showBlock" class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 38 }">
          <div>
            <!-- <span class="text-red-500">*</span> -->
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Regions']['lang_title']}}</span>
            <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="`${lang['components']['Event']['Regions']['lang_title_info']}`"></i>
          </div>
          <div class="flex flex-wrap bg-gray-50 w-full p-2 rounded-md border text-gray-600"
            v-if="stageContenttData.localData.locales">
            <template v-for="(lang, index) in stageContenttData.localData.locales" :key="index">
              <div class="flex justify-between w-full rounded m-1 p-2 text-sm bg-white border border-gray-200" @click="removeLocales(index)">
                <span>{{ lang.name }}</span>
                <i class="pi pi-times mt-1" v-if="!editPageType"></i>
              </div>
            </template>

          </div>
          <div v-if="!editPageType" class=" bg-white rounded-md flex items-center w-full p-2 shadow-sm border border-gray-200">
            <i class="pi pi-search"></i>
            <input type="search" class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
              :placeholder="lang['components']['Event']['Regions']['lang_input_info']" :disabled="editPageType" v-model="searchLang" v-on:keyup="keyup_get_lang();">
          </div>
          <Listbox :disabled="editPageType" v-model="langInput" :options="locale" optionLabel="name" optionValue="key" class="w-full rounded-md"
            emptyMessage="Loading..." v-if="searchLang.length > 0" />
        </div>
        <!-- 新手教學 -->

        <div v-show="stageContenttData.demoData.showBlock" class="bg-gray-100 rounded-lg p-2">
          <span class="font-bold text-grap-700 align-middle">性別與年齡</span>
          <div v-show="stageIndex != 0" class="float-right">
            <span class="text-sm mr-2">套用前階段設定</span>
            <InputSwitch v-model="stageContenttData.demoData.ditto_demo" class="-my-1" :disabled="editPageType" />
          </div>
        </div>
        <div v-show="stageContenttData.demoData.showBlock" class="grid grid-cols-2 gap-8">
          <div class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 39 }">
            <div>
              <!-- <span class="text-red-500">*</span> -->
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Regions']['gender_title']}}</span>
              <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'性別'"></i> -->
            </div>
            <div class="flex flex-wrap space-x-8">
              <Dropdown v-model="stageContenttData.demoData.gender" :disabled="editPageType" optionLabel="name" optionValue="code" :options="gender_interval" class="rounded-md w-full" />
              <!-- <label class="inline-flex items-center mt-3">
                <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="all" :disabled="editPageType" v-model="viewDatalistData.gender">
                <span class="ml-2 text-gray-700">{{lang['components']['Event']['Regions']['gender_item_all']}}</span>
              </label>
              <label class="inline-flex items-center mt-3">
                <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="male" :disabled="editPageType" v-model="viewDatalistData.gender">
                <span class="ml-2 text-gray-700">{{lang['components']['Event']['Regions']['gender_item_male']}}</span>
              </label>
              <label class="inline-flex items-center mt-3">
                <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="female" :disabled="editPageType" v-model="viewDatalistData.gender">
                <span class="ml-2 text-gray-700">{{lang['components']['Event']['Regions']['gender_item_female']}}</span>
              </label> -->
            </div>
          </div>
          <div class="space-y-2 pb-8">
            <div>
              <!-- <span class="text-red-500">*</span> -->
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Regions']['age_title']}}</span>
              <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'預算比率'"></i> -->
            </div>
            <div class="flex flex-wrap">
              <Dropdown v-model="stageContenttData.demoData.age_min" :disabled="editPageType" optionLabel="name" optionValue="code" :options="age_interval" class="rounded-md old-left w-1/2" />
              <Dropdown v-model="stageContenttData.demoData.age_max" :disabled="editPageType" optionLabel="name" optionValue="code" :options="age_interval" class="rounded-md old-right w-1/2" />
            </div>
          </div>
        </div>

        <div v-show="stageContenttData.exAudiencesData.showBlock" class="bg-gray-100 rounded-lg p-2">
          <span class="font-bold text-grap-700 align-middle">{{lang['components']['Event']['Relationship']['title']}}</span>
          <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="`${lang['components']['Event']['Relationship']['title_info']}`"></i>
          <button
            v-if="!editPageType"
            id="relationship"
            class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
            @click="teachVideo()"
          >
            {{lang['components']['Event']['Relationship']['video_teaching']}}
          </button>
          <div v-show="stageIndex != 0" class="float-right">
            <span class="text-sm mr-2">套用前階段設定</span>
            <InputSwitch v-model="stageContenttData.exAudiencesData.ditto_connect" class="-my-1" :disabled="editPageType" />
          </div>
        </div>

        <div v-show="stageContenttData.exAudiencesData.showBlock" class="flex-1 bg-white rounded-xl space-y-6 p-6">
          <div class="flex-1 space-y-4">
            <div class="space-y-2">
              <div class="flex justify-between">
                <div>
                  <!-- <span class="text-red-500">*</span> -->
                  <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Relationship']['default_exclude_audience']}}</span>
                  <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'非必填，最多設定5個'"></i> -->
                </div>
                <!-- 新手教學 -->
                <button
                  v-if="!editPageType"
                  class="text-blue-600 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-2 border-blue-600"
                  :class="{ 'ring-4 border-blue-400': guideStep === 44 }"
                  @click="updateExcludedAudiences()">
                  <i class="pi pi-refresh"></i>
                  {{lang['components']['Event']['Relationship']['exclude_audience_update_text']}}
                </button>
              </div>
              <!-- 新手教學 -->
              <div class="flex flex-wrap bg-white w-full p-2 rounded-md border" :class="{ 'ring-4 border-blue-400': guideStep === 41 }">
                <template v-for="(tag, index) in stageContenttData.exAudiencesData.default_excluded_audiences" :key="tag.code">
                  <!-- <div class="rounded m-1 px-2 py-1 text-sm cursor-pointer" :class="[
                    tag.checked? 'bg-blue-400' : ' bg-gray-200',
                    tag.checked? 'text-white' : 'text-gray-400',
                  ]" @click="tag.checked = !tag.checked">
                    {{ tag.name }}
                  </div> -->
                  <div class="rounded m-1 px-2 py-1 text-sm cursor-pointer" :class="[
                    tag.checked? 'bg-blue-400' : ' bg-gray-200',
                    tag.checked? 'text-white' : 'text-gray-400',
                  ]" @click="defaultExcludedAudiences(tag.checked, index, tag.code)">
                    {{ tag.name }}
                  </div>
                </template>
              </div>
              <div class="pt-8">
                <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Relationship']['customize_exclude_audience']}}</span>
              </div>
              <!-- 新手教學 -->
              <MultiSelect
                :disabled="editPageType"
                v-model="stageContenttData.exAudiencesData.custom_excluded_audiences_selected"
                :options="stageContenttData.exAudiencesData.custom_excluded_audiences"
                optionLabel="name" :placeholder="lang['components']['Event']['Relationship']['customize_exclude_audience_placeholder']"
                :filter="true"
                class="w-full multiselect-custom"
                :class="{ 'ring-4 border-blue-400': guideStep === 43 }"
                @change="onChange($event)"
                display="chip">
              </MultiSelect>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;">
      <div v-show="stageContenttData.exAudiencesData.showBlock" class="flex flex-col bg-white rounded-xl space-y-4 p-4" style="margin-top: 42.5rem;">
        <span class="text-gray-700">{{lang['components']['Event']['Relationship']['selected_exclude_audience']}}</span>
        <!-- 新手教學 -->
        <div class="flex flex-col bg-white w-full p-2 rounded-xl border h-48 overflow-y-auto" :class="{ 'ring-4 border-blue-400': guideStep === 42 }">
          <template v-for="(tag, index) in stageContenttData.exAudiencesData.default_excluded_audiences" :key="tag.code">
            <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white"
              :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="defaultExcludedAudiences(tag.checked, index, tag.code)" v-if="tag.checked">
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
          <template v-for="tag in stageContenttData.exAudiencesData.custom_excluded_audiences_selected" :key="tag.code">
            <div
              class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white"
              @click="removeSelectCustomTags(tag.code)"
            >
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import { emit } from 'vue';
  import MultiSelect from 'primevue/multiselect';
  import InputSwitch from 'primevue/inputswitch';
  import Dropdown from 'primevue/dropdown';
  import Listbox from 'primevue/listbox';
  import InputNumber from 'primevue/inputnumber';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
  import axios from 'axios'
  import Qs from 'qs'

  import TabView from 'primevue/tabview';
  import TabPanel from 'primevue/tabpanel';

  export default {
    name: 'Regions',
    components: {
      MultiSelect,
      InputSwitch,
      Dropdown,
      Listbox,
      InputNumber,
      TabView,
      TabPanel
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: 1
      },
      // <!-- 新手教學 -->
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      stageContent:{
        type: Object
      },
      stageContentAll:{
        type: Object
      },
      stageIndex: {
        type: Number
      },
      viewRelationshipDatalist: {
        type: Object
      },
      campaignId: {
        type: String
      },
      selectCountries: {
        type: Object
      },
      selectLangs: {
        type: Object
      },
      targetDM: {
        type: Boolean
      },
      lang: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      },
      efficientAi: {
        type: Boolean
      }
    },
    data() {
      return {
        type: 'home',
        types: [
          { name: "位於此地點的所有人", code: 'home,recent' },
          { name: "居住在此地點的人", code: 'home' },
          { name: "最近在此地點的人", code: 'recent' },
          { name: "在此地點旅行的人", code: 'travel_in' }
        ],
        country: null,
        langInput: null,
        // selectCountries: [],
        // selectLangs: [],
        countries: [{
            name: '臺灣'
          },
          {
            name: '日本'
          },
          {
            name: '美國'
          },
        ],
        locale: [],
        locale_mark: [],
        locations: [],
        locations_mark: [],
        searchPlace: '',
        searchLang: '',
        // gender: 1,
        oldstart: 46,
        oldend: 64,
        oldS: [
          45, 46, 47, 48
        ],
        oldE: [
          61, 62, 63, 64, '65+'
        ],
        age_interval:[],
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=6vD-2v5RWyk",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
        useGoogleMap: false,
        center: { lat: 23.831, lng: 120.976 },
        cities: {
          chicago: {
            center: { lat: 41.878, lng: -87.629 },
            population: 20,
          },
          newyork: {
            center: { lat: 40.714, lng: -74.005 },
            population: 80,
          },
          losangeles: {
            center: { lat: 34.052, lng: -118.243 },
            population: 48,
          },
          vancouver: {
            center: { lat: 49.25, lng: -123.1 },
            population: 36,
          },
        },
        circles: {},
        markerOptions: [],
        circles_info_show: false,
        GMapMapcenter: {lat: 51.093048, lng: 6.842120},
        germanCities: [
          {
            id: 'duesseldorf',
            population: 612178,
            position: {
              lat: 51.233334, lng: 6.783333
            },
          },
          {
            id: 'koeln',
            position: {
              lat: 50.935173, lng: 6.953101
            },
            population: 1087863
          },
          {
            id: 'Hamburg',
            position: {
              lat: 53.551086,
              lng:  9.993682
            },
            population: 1899160
          }
        ],
        circleOptions: {
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35,
        },
        regionsStatus: false,
        relationshipStatus: false,
        gender_interval: [
          {name: '全部性別', code: 'all'},
          {name: '男性', code: 'male'},
          {name: '女性', code: 'female'},
        ],
        ageGenderStatus: false
      }
    },
    created() {
      if(this.age_interval.length <= 0){
        for(let i = 18; i < 66; i++){
          let name = i;
          let code = i;

          if(i == 65){
            name = '65+';
          }

          this.age_interval.push({name: name, code: code});
        }
      }
    },
    watch: {
      'youtubeClose':function(v){
        // console.log('marketingmethod youtubeClose');
        // console.log(v);

        let _tmpYoutubeType = v.split('_');

        // console.log('_tmpYoutubeType');
        // console.log(_tmpYoutubeType);

        // console.log(typeof this.view_youtube);
        // console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'regions'){
            this.view_youtube = false
          }
        }

        //console.log(typeof this.view_youtube);
        //console.log(this.view_youtube);
      },
      'lang':function(v){
        this.types = [
          { name: this.lang['components']['Event']['Regions']['types_list']['home_recent'], code: 'home,recent' },
          { name: this.lang['components']['Event']['Regions']['types_list']['home'], code: 'home' },
          { name: this.lang['components']['Event']['Regions']['types_list']['recent'], code: 'recent' },
          { name: this.lang['components']['Event']['Regions']['types_list']['travel_in'], code: 'travel_in' }
        ];
      },
      country(v) {
        // console.log('country');
        // console.log(v);

        var inArray = 0

        for (let i = 0; i < this.stageContenttData.localData.locations.length; i++) {
          if (this.stageContenttData.localData.locations[i].key === v) {
            inArray = 1
          }
        }

        if(inArray == 0 && v != null){
          this.stageContenttData.localData.locations.push(this.locations_mark[v])
        }

        // this.$emit('update:selectCountries', this.stageContenttData.localData.locations)
        this.searchPlace = ''

        // console.log(this.selectCountriesData);
      },
      langInput(v) {
        // console.log('lang');
        // console.log(v);
        // this.selectLangs.push(v)
        var inArray = 0

        if(this.stageContenttData.localData.locales != null && this.stageContenttData.localData.locales != '' && this.stageContenttData.localData.locales != 'undefined'){
          for (let i = 0; i < this.stageContenttData.localData.locales.length; i++) {
            if (this.stageContenttData.localData.locales[i].key === v) {
              inArray = 1
            }
          }
        }

        if(inArray == 0 && v != null){
          this.stageContenttData.localData.locales.push(this.locale_mark[v])
        }

        // this.$emit('update:selectLangs', this.stageContenttData.localData.locales)
        this.searchLang = ''

        // console.log(this.selectLangsData);
      },
      selectCountries(v){
        // console.log('regions selectCountries:'+v);
      },
      'stageContenttData.demoData.age_min'(value){
        if(this.stageContenttData.demoData.age_min < 18){
          this.age_interval = [];
          for(let i = 13; i < 66; i++){
            let name = i;
            let code = i;

            if(i == 65){
              name = '65+';
            }

            this.age_interval.push({name: name, code: code});
          }
        }
        // console.log('viewDatalistData.age_min');
        // console.log(value);
        // console.log('viewDatalistData.age_max');
        // console.log(this.viewDatalistData.age_max);
        let age_max = this.stageContenttData.demoData.age_max;

        if(value > age_max){
          Swal.fire(
                      this.lang['components']['Event']['Regions']['watch']['viewDatalistData_age_min']['swal_title'],
                      this.lang['components']['Event']['Regions']['watch']['viewDatalistData_age_min']['swal_text'],
                      "warning"
                    )
        }
      },
      'stageContenttData.demoData.age_max'(value){
        // console.log('viewDatalistData.age_min');
        // console.log(this.viewDatalistData.age_min);
        // console.log('viewDatalistData.age_max');
        // console.log(value);
        let age_min = this.stageContenttData.demoData.age_min;

        if(age_min > value){
          Swal.fire(
                      this.lang['components']['Event']['Regions']['watch']['viewDatalistData_age_max']['swal_title'],
                      this.lang['components']['Event']['Regions']['watch']['viewDatalistData_age_max']['swal_text'],
                      "warning"
                    )
        }
      },
      'stageContenttData.localData.location_item'(value){
        // console.log('location_item');

        // this.$refs.youtube.playVideo()

        // this.$refs.tabview1.activeIndex = value;

        // this.$emit("update:activeIndex", value);

        // $emit("update:activeIndex", value)
      },
      'stageContenttData.localData.location_range'(value){
        // console.log('viewDatalistData.location_range');
        // console.log(value);

        this.cities = value;

        // console.log(this.cities);

        for (const key in this.cities) {
          this.circles[key] = {
            center: this.cities[key].center,
            radius: this.cities[key].population * 1000,
            strokeColor: "#0000C6",
            strokeOpacity: 0.7,
            strokeWeight: 1,
            fillColor: "#CECEFF",
            fillOpacity: 0.3,
            lat: this.cities[key].center['lat'],
            lng: this.cities[key].center['lng']
          };

          this.markerOptions[key] = {
            position: this.cities[key].center,
            label: key,
            title: key
          };

          // // 創建一個包含經緯度坐標的 LatLng 物件
          // var latlng = new google.maps.LatLng(this.cities[key].center['lat'], this.cities[key].center['lng']);

          // // 創建一個逆地理編碼的 Geocoder 物件
          // var geocoder = new google.maps.Geocoder();

          // // 使用 geocoder 對經緯度進行逆地理編碼
          // geocoder.geocode({ 'latLng': latlng }, function(results, status) {
          //   if (status == google.maps.GeocoderStatus.OK) {
          //     if (results[1]) {
          //       // results[1] 包含了逆地理編碼後的詳細地址資訊
          //       console.log(results[1].formatted_address);
          //     } else {
          //       console.log('無法找到該位置的資訊。');
          //     }
          //   } else {
          //     console.log('逆地理編碼失敗，錯誤訊息：' + status);
          //   }
          // });

        }

        // console.log('this.circles_info_show');
        // console.log(this.circles_info_show);

        if(value != null){
          const location_range_array = Object.keys(value);

          if(location_range_array.length <= 0){
            this.circles_info_show = true;
          }
        }

        // console.log('this.markerOptions');
        // console.log(this.markerOptions);
      },
      'stageContenttData.localData.ditto_local'(value){
        console.log('stageContenttData.localData.ditto_local');
        console.log(value);
        console.log('b this.stageContentAllData');
        console.log(this.stageContentAllData);
        console.log(this.stageContenttData);
        console.log(this.stageIndex);

        if(this.stageIndex > 0){
          if(value == true){
            let _beforIndex = this.stageIndex - parseInt(1);

            // this.stageContentAllData.subCampaignsContent[this.stageIndex].localData = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].localData));

            // this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.ditto_local = value;
            this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.locales = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].localData.locales));
            this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.location_range = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].localData.location_range));
            this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.location_types = this.stageContentAllData.subCampaignsContent[_beforIndex].localData.location_types;
            this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.locations = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].localData.locations));

            this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.ditto_local = value;

            console.log('for this.stageContentAllData.subCampaignsContent[this.stageIndex]');
            console.log(this.stageContentAllData.subCampaignsContent[this.stageIndex]);

            let subLength =  this.stageContentAllData.subCampaignsContent.length;
            console.log('this.stageIndex');
            console.log(this.stageIndex);
            for(let i = this.stageIndex; i < subLength; i++){
              console.log(this.stageContentAllData.subCampaignsContent[i].localData);
              if(this.stageContentAllData.subCampaignsContent[i].localData.ditto_local == true){
                this.stageContentAllData.subCampaignsContent[i].localData.locales = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.locales));
                this.stageContentAllData.subCampaignsContent[i].localData.location_range = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.location_range));
                this.stageContentAllData.subCampaignsContent[i].localData.location_types = this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.location_types;
                this.stageContentAllData.subCampaignsContent[i].localData.locations = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.locations));
              } else {
                break;
              }
            }
          }
        }

        console.log('a this.stageContentAllData');
        console.log(this.stageContentAllData);
      },
      'stageContenttData.demoData.ditto_demo'(value){
        console.log('stageContenttData.demoData.ditto_demo');
        console.log(value);
        console.log('b this.stageContentAllData');
        console.log(this.stageContentAllData);
        console.log(this.stageContenttData);
        console.log(this.stageIndex);

        if(this.stageIndex > 0){
          if(value == true){
            let _beforIndex = this.stageIndex - parseInt(1);

            // this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].demoData));

            // this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.ditto_demo = value;
            this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.gender = this.stageContentAllData.subCampaignsContent[_beforIndex].demoData.gender;
            this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.age_min = this.stageContentAllData.subCampaignsContent[_beforIndex].demoData.age_min;
            this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.age_max = this.stageContentAllData.subCampaignsContent[_beforIndex].demoData.age_max;

            this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.ditto_demo = value;

            console.log('for this.stageContentAllData.subCampaignsContent[this.stageIndex]');
            console.log(this.stageContentAllData.subCampaignsContent[this.stageIndex]);

            let subLength =  this.stageContentAllData.subCampaignsContent.length;
            console.log('this.stageIndex');
            console.log(this.stageIndex);
            for(let i = this.stageIndex; i < subLength; i++){
              console.log(this.stageContentAllData.subCampaignsContent[i].demoData);
              if(this.stageContentAllData.subCampaignsContent[i].demoData.ditto_demo == true){
                this.stageContentAllData.subCampaignsContent[i].demoData.gender = this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.gender;
                this.stageContentAllData.subCampaignsContent[i].demoData.age_min = this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.age_min;
                this.stageContentAllData.subCampaignsContent[i].demoData.age_max = this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.age_max;
              } else {
                break;
              }
            }
          }
        }

        console.log('a this.stageContentAllData');
        console.log(this.stageContentAllData);
      },
      'stageContenttData.exAudiencesData.ditto_connect'(value){
        console.log('stageContenttData.exAudiencesData.ditto_connect');
        console.log(value);
        console.log('b this.stageContentAllData');
        console.log(this.stageContentAllData);
        console.log(this.stageContenttData);
        console.log(this.stageIndex);

        if(this.stageIndex > 0){
          if(value == true){
            let _beforIndex = this.stageIndex - parseInt(1);

            // this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].exAudiencesData));

            // this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.ditto_connect = value;
            this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.excluded_audiences = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].exAudiencesData.excluded_audiences));
            this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.default_excluded_audiences = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].exAudiencesData.default_excluded_audiences));
            this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.custom_excluded_audiences = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].exAudiencesData.custom_excluded_audiences));
            this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.custom_excluded_audiences_selected = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].exAudiencesData.custom_excluded_audiences_selected));

            this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.ditto_connect = value;

            console.log('for this.stageContentAllData.subCampaignsContent[this.stageIndex]');
            console.log(this.stageContentAllData.subCampaignsContent[this.stageIndex]);

            let subLength =  this.stageContentAllData.subCampaignsContent.length;
            console.log('this.stageIndex');
            console.log(this.stageIndex);
            for(let i = this.stageIndex; i < subLength; i++){
              console.log(this.stageContentAllData.subCampaignsContent[i].exAudiencesData);
              if(this.stageContentAllData.subCampaignsContent[i].exAudiencesData.ditto_connect == true){
                this.stageContentAllData.subCampaignsContent[i].exAudiencesData.excluded_audiences = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.excluded_audiences));
                this.stageContentAllData.subCampaignsContent[i].exAudiencesData.default_excluded_audiences = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.default_excluded_audiences));
                this.stageContentAllData.subCampaignsContent[i].exAudiencesData.custom_excluded_audiences = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.custom_excluded_audiences));
                this.stageContentAllData.subCampaignsContent[i].exAudiencesData.custom_excluded_audiences_selected = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.custom_excluded_audiences_selected));
              } else {
                break;
              }
            }
          }
        }

        console.log('a this.stageContentAllData');
        console.log(this.stageContentAllData);
      },
      'stageContenttData.localData': {
        handler(newValue, oldValue) {
          console.log('localData changed:', newValue);
          console.log('localData olddata:', oldValue);
          console.log(this.stageIndex);
          console.log(this.stageContentAllData);

          console.log('stageContenttData.localData');
          console.log(this.stageContentAllData);

          if(this.stageIndex > 0){
            let _beforeIndex = this.stageIndex - parseInt(1);

            console.log(this.stageContentAllData.subCampaignsContent);
            console.log(this.stageContentAllData.subCampaignsContent[_beforeIndex]);
            console.log(this.stageContentAllData.subCampaignsContent[_beforeIndex].localData);
            let _newDataLocales = JSON.stringify(newValue.locales);
            let _newDataLocationRange = JSON.stringify(newValue.location_range);
            let _newDataLocations = JSON.stringify(newValue.locations);
            let _oldDataLocales = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].localData.locales);
            let _oldDataLocationRange = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].localData.location_range);
            let _oldDataLocations = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].localData.locations);

            console.log(_newDataLocales);
            console.log(_oldDataLocales);
            console.log(_newDataLocationRange);
            console.log(_oldDataLocationRange);
            console.log(_newDataLocations);
            console.log(_oldDataLocations);
            console.log(newValue.ditto_local);

            if((_newDataLocales == _oldDataLocales) && (_newDataLocationRange == _oldDataLocationRange) && (_newDataLocations == _oldDataLocations) && newValue.ditto_local == true){
              console.log('#一樣');
              this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.ditto_local = true;
            } else {
              console.log('#不一樣');
              this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.ditto_local = false;
            }
          } else {
            let subLength =  this.stageContentAllData.subCampaignsContent.length;
            console.log('0');
            console.log(this.stageIndex);
            for(let i = 1; i < subLength; i++){
              console.log('this.stageContentAllData.subCampaignsContent['+i+'].localData');
              console.log(this.stageContentAllData.subCampaignsContent[i].localData);
              if(this.stageContentAllData.subCampaignsContent[i].localData.ditto_local == true){
                this.stageContentAllData.subCampaignsContent[i].localData.locales = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.locales));
                this.stageContentAllData.subCampaignsContent[i].localData.location_range = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.location_range));
                this.stageContentAllData.subCampaignsContent[i].localData.location_types = this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.location_types;
                this.stageContentAllData.subCampaignsContent[i].localData.locations = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].localData.locations));
              } else {
                break;
              }
            }
          }

          console.log('b this.stageContentAllData');
          console.log(this.stageContentAllData);
        },
        deep: true // 深度监控
      },
      'stageContenttData.demoData': {
        handler(newValue, oldValue) {
          console.log('demoData changed:', newValue);
          console.log('demoData olddata:', oldValue);
          console.log(this.stageIndex);
          console.log(this.stageContentAllData);

          console.log('stageContenttData.demoData');
          console.log(this.stageContentAllData);

          if(this.stageIndex > 0){
            let _beforeIndex = this.stageIndex - parseInt(1);

            console.log(this.stageContentAllData.subCampaignsContent);
            console.log(this.stageContentAllData.subCampaignsContent[_beforeIndex]);
            console.log(this.stageContentAllData.subCampaignsContent[_beforeIndex].demoData);
            let _newDataGender = newValue.gender;
            let _newDataAgeMin = newValue.age_min;
            let _newDataAgeMax = newValue.age_max;
            let _oldDataGender = this.stageContentAllData.subCampaignsContent[_beforeIndex].demoData.gender;
            let _oldDataAgeMin = this.stageContentAllData.subCampaignsContent[_beforeIndex].demoData.age_min;
            let _oldDataAgeMax = this.stageContentAllData.subCampaignsContent[_beforeIndex].demoData.age_max;

            console.log(_newDataGender);
            console.log(_oldDataGender);
            console.log(_newDataAgeMin);
            console.log(_oldDataAgeMin);
            console.log(_newDataAgeMax);
            console.log(_oldDataAgeMax);
            console.log(newValue.ditto_demo);

            if((_newDataGender == _oldDataGender) && (_newDataAgeMin == _oldDataAgeMin) && (_newDataAgeMax == _oldDataAgeMax) && newValue.ditto_demo == true){
              console.log('#一樣');
              this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.ditto_demo = true;
            } else {
              console.log('#不一樣');
              this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.ditto_demo = false;
            }
          } else {
            let subLength =  this.stageContentAllData.subCampaignsContent.length;
            console.log('0');
            console.log(this.stageIndex);
            for(let i = 1; i < subLength; i++){
              console.log('this.stageContentAllData.subCampaignsContent['+i+'].demoData');
              console.log(this.stageContentAllData.subCampaignsContent[i].demoData);
              if(this.stageContentAllData.subCampaignsContent[i].demoData.ditto_demo == true){
                this.stageContentAllData.subCampaignsContent[i].demoData.gender = this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.gender;
                this.stageContentAllData.subCampaignsContent[i].demoData.age_min = this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.age_min;
                this.stageContentAllData.subCampaignsContent[i].demoData.age_max = this.stageContentAllData.subCampaignsContent[this.stageIndex].demoData.age_max;
              } else {
                break;
              }
            }
          }

          console.log('b this.stageContentAllData');
          console.log(this.stageContentAllData);
        },
        deep: true // 深度监控
      },
      'stageContenttData.exAudiencesData': {
        handler(newValue, oldValue) {
          console.log('exAudiencesData changed:', newValue);
          console.log('exAudiencesData olddata:', oldValue);
          console.log(this.stageIndex);
          console.log(this.stageContentAllData);

          console.log('stageContenttData.exAudiencesData');
          console.log(this.stageContentAllData);

          if(this.stageIndex > 0){
            let _beforeIndex = this.stageIndex - parseInt(1);

            console.log(this.stageContentAllData.subCampaignsContent);
            console.log(this.stageContentAllData.subCampaignsContent[_beforeIndex]);
            console.log(this.stageContentAllData.subCampaignsContent[_beforeIndex].exAudiencesData);
            let _newDataExcludedAudiences = JSON.stringify(newValue.excluded_audiences);
            let _newDataDefaultExcludedAudiences = JSON.stringify(newValue.default_excluded_audiences);
            let _newDataCustomExcludedAudiences = JSON.stringify(newValue.custom_excluded_audiences);
            let _newDataCustomExcludedAudiencesSelected = JSON.stringify(newValue.custom_excluded_audiences_selected);
            let _oldDataExcludedAudiences = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].exAudiencesData.excluded_audiences);
            let _oldDataDefaultExcludedAudiences = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].exAudiencesData.default_excluded_audiences);
            let _oldDataCustomExcludedAudiences = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].exAudiencesData.custom_excluded_audiences);
            let _oldDataCustomExcludedAudiencesSelected = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].exAudiencesData.custom_excluded_audiences_selected);

            console.log(_newDataExcludedAudiences);
            console.log(_oldDataExcludedAudiences);
            console.log(_newDataDefaultExcludedAudiences);
            console.log(_oldDataDefaultExcludedAudiences);
            console.log(_newDataCustomExcludedAudiences);
            console.log(_oldDataCustomExcludedAudiences);
            console.log(_newDataCustomExcludedAudiencesSelected);
            console.log(_oldDataCustomExcludedAudiencesSelected);
            console.log(newValue.ditto_connect);

            if((_newDataExcludedAudiences == _oldDataExcludedAudiences) && (_newDataDefaultExcludedAudiences == _oldDataDefaultExcludedAudiences) && (_newDataCustomExcludedAudiences == _oldDataCustomExcludedAudiences) && (_newDataCustomExcludedAudiencesSelected == _oldDataCustomExcludedAudiencesSelected) && newValue.ditto_connect == true){
              console.log('#一樣');
              this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.ditto_connect = true;
            } else {
              console.log('#不一樣');
              this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.ditto_connect = false;
            }
          } else {
            let subLength =  this.stageContentAllData.subCampaignsContent.length;
            console.log('0');
            console.log(this.stageIndex);
            for(let i = 1; i < subLength; i++){
              console.log('this.stageContentAllData.subCampaignsContent['+i+'].exAudiencesData');
              console.log(this.stageContentAllData.subCampaignsContent[i].exAudiencesData);
              if(this.stageContentAllData.subCampaignsContent[i].exAudiencesData.ditto_connect == true){
                this.stageContentAllData.subCampaignsContent[i].exAudiencesData.excluded_audiences = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.excluded_audiences));
                this.stageContentAllData.subCampaignsContent[i].exAudiencesData.default_excluded_audiences = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.default_excluded_audiences));
                this.stageContentAllData.subCampaignsContent[i].exAudiencesData.custom_excluded_audiences = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.custom_excluded_audiences));
                this.stageContentAllData.subCampaignsContent[i].exAudiencesData.custom_excluded_audiences_selected = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].exAudiencesData.custom_excluded_audiences_selected));
              } else {
                break;
              }
            }
          }

          console.log('b this.stageContentAllData');
          console.log(this.stageContentAllData);
        },
        deep: true // 深度监控
      },
    },
    methods: {
      onReady() {
        // console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
        // console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('marketingDate');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_regions')

        this.vars.start = 228
        this.vars.end = 260
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
        // console.log(val)
      },
      doDragging(){
        // console.log('doDragging');
      },
      locationTypes(event) {
        // console.log('locationTypes');
        // console.log(event.value);
      },
      onTabClick(event){
        // console.log('onTabClick');
        // console.log(event);

        this.stageContenttData.localData.location_item = event.index

        if(event.index == 1){
          this.useGoogleMap = true
        }
      },
      removeLocations(index) {
        // console.log('remove');
        // console.log(index);
        if(this.editPageType == false){
          this.stageContenttData.localData.locations.splice(index, 1);

          // this.$emit('update:selectCountries', this.stageContenttData.localData.locations)

        }
      },
      removeLocales(index) {
        // console.log('remove');
        // console.log(index);
        if(this.editPageType == false){
          this.stageContenttData.localData.locales.splice(index, 1);

          // this.$emit('update:selectLangs', this.stageContenttData.localData.locales)
        }
      },
      keyup_get_lang(){
        // console.log('searchLang');
        // console.log(this.searchLang);

        this.langInput = null
        this.locale = null

        if(this.editPageType == false){
          axios
            .post('https://www.autoturn.net/api/campaign_form_locale_search.php', Qs.stringify({
              s_code: this.$route.params.id,
              q: this.searchLang
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                this.locale = response.data.return_data
                this.locale_mark = response.data.return_data_mark
              }
            });
        }
      },
      keyup_get_country(){
        // console.log('searchPlace');
        // console.log(this.searchPlace);
        // console.log('selectCountriesData');
        // console.log(this.selectCountriesData);
        // console.log('country');
        // console.log(this.country);

        this.country = null
        this.locations = null

        if(this.editPageType == false){
          axios
          .post('https://www.autoturn.net/api/campaign_form_locations_search.php', Qs.stringify({
            s_code: this.$route.params.id,
            q: this.searchPlace
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
              this.locations = response.data.return_data
              this.locations_mark = response.data.return_data_mark
            }
          });
        }

      },
      mapActive(v){
        //console.log('mapActive');
        //console.log(v);
        // console.log(typeof this.cities);
        // console.log(this.cities);
        // console.log(v.latLng);
        // console.log(v.latLng.lat);
        // console.log(v.latLng.lat.Scopes);
        // console.log(v.latLng.lat.Scopes[0].block);
        // console.log(v.latLng.lat.block);
        // console.log(v.latLng.lat['Scopes']);
        // console.log(v.latLng.lat['Scopes'].block);
        // console.log(v.latLng.lat['Scopes']['block']);

        //console.log(v.latLng.lat());
        //console.log(v.latLng.lng());

        let latLng = v.latLng;

        let todayForm = new Date();
        let yearForm = todayForm.getFullYear();
        let dateForm = String(todayForm.getDate()).padStart(2, '0');
        let monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        let timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        todayForm = yearForm + monthForm + dateForm + timeForm;

        this.circles[todayForm] = {
          center: { lat: v.latLng.lat(), lng: v.latLng.lng() },
          radius: 16000,
          strokeColor: "#0000C6",
          strokeOpacity: 0.7,
          strokeWeight: 1,
          fillColor: "#CECEFF",
          fillOpacity: 0.3,
          lat: v.latLng.lat(),
          lng: v.latLng.lng()
        };

        let lat = v.latLng.lat();
        let lng = v.latLng.lng();

        //console.log('b viewDatalistData.location_range');
        //console.log(this.viewDatalistData.location_range);

        this.stageContenttData.localData.location_range[todayForm] = {
          center: { lat: parseFloat(lat.toFixed(3)), lng: parseFloat(lng.toFixed(3)) },
          population: 16,
          lat: v.latLng.lat(),
          lng: v.latLng.lng(),
          checked: false
        };

        //console.log('a viewDatalistData.location_range');
        //console.log(this.viewDatalistData.location_range);

        this.markerOptions[todayForm] = { position: { lat: parseFloat(lat.toFixed(3)), lng: parseFloat(lng.toFixed(3)) }, label: todayForm, title: todayForm };

        //console.log('this.markerOptions');
        //console.log(this.markerOptions);

        this.circleStyle(todayForm);

        this.circles_info_show = false;

        //console.log('typeof viewDatalistData.location_range');
        //console.log(typeof this.viewDatalistData.location_range);
        //console.log(this.viewDatalistData.location_range);

        //console.log('circles');
        //console.log(this.circles);
      },
      change(){
        //console.log('b circles');
        //console.log(this.circles);
        // Object.entries(this.circles).forEach(entry => {
        //   const [key, value] = entry;
        //   value.strokeColor = '#CE0000';
        //   value.fillColor = '#FF9797';
        // });
        for (const key in this.cities) {
          this.circles[key] = {
            strokeColor: "#CE0000",
            fillColor: "#FF9797",
          };
        }
        //console.log('a circles');
        //console.log(this.circles);
      },
      circleStyle(v){
        //console.log('circleStyle');
        //console.log(v);

        //console.log('b circles');
        //console.log(this.circles);
        //console.log('b this.center');
        //console.log(this.center);

        this.center = this.stageContenttData.localData.location_range[v].center;

        for (const key in this.cities) {
          this.circles[key] = {
            center: this.stageContenttData.localData.location_range[key].center,
            radius: this.stageContenttData.localData.location_range[key].population * 1000,
            strokeColor: "#0000C6",
            strokeOpacity: 0.7,
            strokeWeight: 1,
            fillColor: "#CECEFF",
            fillOpacity: 0.3,
            lat: this.stageContenttData.localData.location_range[key].center['lat'],
            lng: this.stageContenttData.localData.location_range[key].center['lng']
          };

          this.stageContenttData.localData.location_range[key] = {
            center: this.stageContenttData.localData.location_range[key].center,
            population: this.stageContenttData.localData.location_range[key].population,
            lat: this.stageContenttData.localData.location_range[key].center['lat'],
            lng: this.stageContenttData.localData.location_range[key].center['lng'],
            checked: false
          };
        }

        this.circles[v] = {
          center: this.stageContenttData.localData.location_range[v].center,
          radius: this.stageContenttData.localData.location_range[v].population * 1000,
          strokeColor: "#CE0000",
          strokeOpacity: 0.7,
          strokeWeight: 1,
          fillColor: "#FF9797",
          fillOpacity: 0.3,
          lat: this.stageContenttData.localData.location_range[v].center['lat'],
          lng: this.stageContenttData.localData.location_range[v].center['lng']
        };

        this.stageContenttData.localData.location_range[v] = {
          center: this.stageContenttData.localData.location_range[v].center,
          population: this.stageContenttData.localData.location_range[v].population,
          lat: this.stageContenttData.localData.location_range[v].center['lat'],
          lng: this.stageContenttData.localData.location_range[v].center['lng'],
          checked: true
        };

        //console.log('a circles');
        //console.log(this.circles);
        //console.log('a this.center');
        //console.log(this.center);
      },
      circleDelect(v){
        delete this.circles[v];
        delete this.stageContenttData.localData.location_range[v];

        //console.log('circleDelect');
        //console.log(this.circles);
        //console.log(this.stageContenttData.localData.location_range);

        const location_range_array = Object.keys(this.stageContenttData.localData.location_range);

        if(location_range_array.length <= 0){
          this.circles_info_show = true;
        }
      },
      updateCoordinates(index, location) {
        // this.coordinates = {
        //     lat: location.latLng.lat(),
        //     lng: location.latLng.lng(),
        // };

        //console.log('updateCoordinates');
        //console.log(index);
        //console.log(location);
        // console.log(this.coordinates);

        if(this.editPageType == false){
          this.circles[index].center = { lat: location.latLng.lat(), lng: location.latLng.lng()};
          this.circles[index].lat = location.latLng.lat();
          this.circles[index].lng = location.latLng.lng();
          this.stageContenttData.localData.location_range[index].center = { lat: location.latLng.lat(), lng: location.latLng.lng()};
          this.stageContenttData.localData.location_range[index].lat = location.latLng.lat();
          this.stageContenttData.localData.location_range[index].lng = location.latLng.lng();
        }

        //console.log(this.circles);
        //console.log(this.location_range);
      },
      removeSelectCustomTags(id) {
        if(this.editPageType == false){
          for (let i = 0; i < this.stageContenttData.exAudiencesData.custom_excluded_audiences_selected.length; i++) {
            if (this.stageContenttData.exAudiencesData.custom_excluded_audiences_selected[i].code === id) {
              this.stageContenttData.exAudiencesData.custom_excluded_audiences_selected.splice(i, 1);
            }
          }
        }
      },
      defaultExcludedAudiences(checked, index, code){
        let itemLength = 0

        if(this.editPageType == false){
          for (let i = 0; i < this.stageContenttData.exAudiencesData.default_excluded_audiences.length; i++) {
            if (this.stageContenttData.exAudiencesData.default_excluded_audiences[i].checked == true) {
              itemLength = parseInt(itemLength) + parseInt(1);
            }
          }

          itemLength = parseInt(itemLength) + this.stageContenttData.exAudiencesData.custom_excluded_audiences_selected.length

          if(checked == false){
            if(itemLength < 10){
              for (let i = 0; i < this.stageContenttData.exAudiencesData.default_excluded_audiences.length; i++) {
                if (this.stageContenttData.exAudiencesData.default_excluded_audiences[i].code === code) {
                  this.stageContenttData.exAudiencesData.default_excluded_audiences[i].checked = true
                }
              }
            } else {
              Swal.fire(
                        this.lang['components']['Event']['Relationship']['methods']['defaultExcludedAudiences']['swal_title'],
                        this.lang['components']['Event']['Relationship']['methods']['defaultExcludedAudiences']['swal_text'],
                        "error"
                      )
            }
          } else {
            for (let i = 0; i < this.stageContenttData.exAudiencesData.default_excluded_audiences.length; i++) {
              if (this.stageContenttData.exAudiencesData.default_excluded_audiences[i].code === code) {
                this.stageContenttData.exAudiencesData.default_excluded_audiences[i].checked = false
              }
            }
          }
        }
      },
      updateExcludedAudiences(){
        // console.log('updateExcludedAudiences');
        // console.log(this.viewDatalistData);
        if(this.editPageType == false){
          this.showRelationshipMyside = false;

          axios
            .post('https://test.autoturn.net/inside/api/campaign_excluded_audiences_list_update.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              campaign_id:this.campaignId
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                this.stageContenttData.exAudiencesData.excluded_audiences = response.data.excluded_audiences
                this.stageContenttData.exAudiencesData.default_excluded_audiences = response.data.default_excluded_audiences
                this.stageContenttData.exAudiencesData.custom_excluded_audiences = response.data.custom_excluded_audiences
                this.stageContenttData.exAudiencesData.custom_excluded_audiences_selected = response.data.custom_excluded_audiences_selected
              }

              this.showRelationshipMyside = true;
            });
        }
      },
      onChange(event) {
        // this.selectAll = event.value.length === this.items.length
        let itemLength = 0

        if(this.editPageType == false){
          for (let i = 0; i < this.stageContenttData.exAudiencesData.default_excluded_audiences.length; i++) {
            if (this.stageContenttData.exAudiencesData.default_excluded_audiences[i].checked == true) {
              itemLength = parseInt(itemLength) + parseInt(1);
            }
          }

          itemLength = parseInt(itemLength) + event.value.length

          if(itemLength > 10){
            event.value.pop();

            Swal.fire(
                        this.lang['components']['Event']['Relationship']['methods']['onChange']['swal_title'],
                        this.lang['components']['Event']['Relationship']['methods']['onChange']['swal_text'],
                        "error"
                      )
          }
        }
      }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
      stageContenttData:{
        get: function () {
          return this.stageContent
        },
        set: function (value) {
          this.$emit('update:stageContenttData', value)
        },
      },
      stageContentAllData:{
        get: function () {
          return this.stageContentAll
        },
        set: function (value) {
          this.$emit('update:stageContentAllData', value)
        },
      },
      viewRelationshipDatalistData: {
        get: function () {
          return this.viewRelationshipDatalist
        },
        set: function (value) {
          this.$emit('update:viewRelationshipDatalistData', value)
        },
      },
      selectCountriesData: {
        get: function () {
          return this.selectCountries
        },
        set: function (value) {
          this.$emit('update:selectCountriesData', value)
        },
      },
      selectLangsData: {
        get: function () {
          return this.selectLangs
        },
        set: function (value) {
          this.$emit('update:selectLangsData', value)
        },
      },
      targetDMData: {
        get: function () {
          return this.targetDM
        },
        set: function (value) {
          this.$emit('update:targetDMData', value)
        },
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep() {
    .old-left {
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      border-right: 0px;
    }

    .old-right {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
</style>